import React, {Component} from 'react'
import {Field, FieldsManager} from '../../../../data/services/fields'
import {
    checkPerm,
    getDefaultTableOptions,
    getLookup,
    getProp,
    returnOffsetAndPagination
} from '../../../../common/util/util-helpers'
import {CREATE_PERM, DEFAULT_CRUD_STATE, DELETE_PERM, MAJOR_ACCOUNT_TYPE_EXPENSE} from '../../../../util/util-constants'
import {TrashIcon, PencilIcon} from '@heroicons/react/24/outline'
import LocalStorage from '../../../../util/localStorage'
import Resources from '../../../../data/services/resources'
import ModalConfirm from "../../../../common/components/modal/modal-confirm";
import ModalSaveResource from "../../../../common/components/modal/modal-save-resource";
import Pagination from "../../../../common/components/resource-table/table-components/pagination";
import ResourceTable from "../../../../common/components/resource-table";
import TableFilters from "../../../../common/components/resource-table/table-components/table-filters";
import TableCard from "../../../../common/components/resource-table/table-components/table-card";
import TableCardFooter from "../../../../common/components/resource-table/table-components/table-card-footer";
import ActiveFilters from "../../../../common/components/resource-table/table-components/active-filters";
import {DEFAULT_QUERY_LIMIT, UPDATE_PERM} from '../../../../common/util/util-consts'
import {fillFieldsFromData} from "../../../../common/util/util-fields";
import {
    createSecondResource,
    deleteSecondResource,
    getSecondResource,
    updateSecondResource
} from "../../../../data/actions/secondResource";

export default class DriverPayrollOverrides extends Component {
    constructor(props) {
        super(props)
        this.pagePath = this.props.location.pathname.substring(1) + '_override'
        this.state = {
            ...DEFAULT_CRUD_STATE,
            fields: this.getFields(),
            queryFilterFields: this.getQueryFilterFields(),
            tableOptions: getDefaultTableOptions(this.getFields(), {}, this.pagePath, this.props.translate),
            createModalOpen: false,
            editModalOpen: false,
            selectedItem: null,
            confirmDialog: false

        }
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData()
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getSecondResource({
            user: LocalStorage.get('user'),
            resource: this.getSettingsResource(),
            query: this.getQuery()
        }))
    }

    /** UI Events
     ================================================================= */
    getQuery = () => {
        return {
            sort: this.state.sort,
            sortBy: this.state.sortBy,
            offset: this.state.offset,
            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFields),
        }
    }

    getQueryFilterFields = () => {
        return {
            query: new Field('query', '', [''], false, 'search'),
            limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true}, {menuPlacement: 'top'})
        }
    }

    saveFilters = () => {
        LocalStorage.persistState(this.pagePath, this.state, ['sortBy', 'sort', 'query', 'offset'])
    }

    handleToggleCreateModal = () => {
        this.setState({createModalOpen: !this.state.createModalOpen})
    }

    handleUpdateOffset = (offset, num) => {
        this.setState({
            offset: offset,
            paginationPage: num
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleInputChange = (name, value) => {
        const fields = FieldsManager.updateField(this.state.fields, name, value)

        this.setState({
            fields: fields
        })
    }

    handleToggleConfirmDialog = (submit) => {
        this.setState({
            confirmModal: submit,
            confirmDialog: !this.state.confirmDialog
        })
    }

    archiveResource = (item = null) => {
        this.setState({text: `${this.props.translate('message.are_you_sure_delete_item')}`}, () => {
            this.handleToggleConfirmDialog(() => {
                this.setState({
                    ...returnOffsetAndPagination(getProp(this.props.secondResource.data, 'list', []), this.getQuery(), this.state.paginationPage),
                    confirmDialog: false
                }, () => {
                    this.props.dispatch(deleteSecondResource({
                        user: LocalStorage.get('user'),
                        query: {
                            PayrollSettingsID: item?.PayrollSettingsID,
                        },
                        piggyQuery: this.getQuery(),
                        errorMessage: true, successMessage: `Item has been deleted`,
                        resource: this.getSettingsResource(),
                        secondPiggyResource: this.getSettingsResource()
                    }))
                })
            }, item)
        })
    }

    handleFilterInputChange = (name, value) => {
        let queryFields = FieldsManager.updateField(this.state.queryFilterFields, name, value)

        this.setState({
            queryFilterFields: queryFields,
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleUpdateSort = (sortBy) => {
        this.setState({
            sortBy: sortBy,
            sort: (this.state.sortBy === sortBy) ? (this.state.sort === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleToggleEditModal = (item = null) => {
        this.setState({selectedItem: item, editModalOpen:!this.state.editModalOpen})
    }
    /** Helpers
     ================================================================= */
    getSettingsResource = () => {
        return Resources.PayrollSettingsDriver
    }

    getFields = (item = null, areModalFields) => {
        const fieldTemplates = {
            DriverPositionTypeID: new Field('DriverPositionTypeID', '', ['empty'], false, 'select', {},
                {values: getLookup('DriverPositionType', 'DriverPositionTypeID', 'DriverPositionType')}),
            ShowDispatchPay: new Field('ShowDispatchPay', '', [''], false, 'checkbox', {}, {}),
            HidePayrollBalances: new Field('HidePayrollBalances', '', [''], false, 'checkbox', {}, {}),
            ShowNegativePayCheck: new Field('ShowNegativePayCheck', '', [''], false, 'checkbox', {}, {}),
            ShowDetailedDeductions: new Field('ShowDetailedDeductions', '', [''], false, 'checkbox', {}, {}),
            SplitPositiveNegativeOnDetailed: new Field('SplitPositiveNegativeOnDetailed', '', [''], false, 'checkbox', {}, {}),
            HideDispatcher: new Field('HideDispatcher', '', [''], false, 'checkbox', {}, {}),
            HideYTD: new Field('HideYTD', '', [''], false, 'checkbox', {}, {}),
            ShowDriverAddress: new Field('ShowDriverAddress', '', [''], false, 'checkbox', {}, {}),
            SplitTollsOnSettlement: new Field('SplitTollsOnSettlement', '', [''], false, 'checkbox', {}, {}),
            ShowTrucksForDrivers: new Field('ShowTrucksForDrivers', '', [''], false, 'checkbox', {}, {}),
            ShowMileage: new Field('ShowMileage', '', [''], false, 'checkbox', {}, {}),
            ShowRateType: new Field('ShowRateType', '', [''], false, 'checkbox', {}, {}),
        }

        if (areModalFields) {
            fieldTemplates.ShowDispatchPay.props.id = "ShowDispatchPayModal"
            fieldTemplates.HidePayrollBalances.props.id = "HidePayrollBalancesModal"
            fieldTemplates.ShowNegativePayCheck.props.id = "ShowNegativePayCheckModal"
            fieldTemplates.ShowDetailedDeductions.props.id = "ShowDetailedDeductionsModal"
            fieldTemplates.SplitPositiveNegativeOnDetailed.props.id = "SplitPositiveNegativeOnDetailedModal"
            fieldTemplates.HideDispatcher.props.id = "HideDispatcherModal"
            fieldTemplates.HideYTD.props.id = "HideYTDModal"
            fieldTemplates.ShowDriverAddress.props.id = "ShowDriverAddressModal"
            fieldTemplates.SplitTollsOnSettlement.props.id = "SplitTollsOnSettlementModal"
            fieldTemplates.ShowTrucksForDrivers.props.id = "ShowTrucksForDriversModal"
            fieldTemplates.ShowMileage.props.id = "ShowMileageModal"
            fieldTemplates.ShowRateType.props.id = "ShowRateTypeModal"
        }

        return fillFieldsFromData(fieldTemplates, item)
    }

    render() {
        const {translate, secondResource} = this.props

        const data = getProp(this.props.secondResource, 'data.list', [])
        const count = getProp(this.props.secondResource, 'data.count', 0)

        return (
            <div>
                {checkPerm(this.getSettingsResource(), CREATE_PERM) && (
                    <div className="flex m-4 justify-end">
                        <button className={'btn btn-primary mt-2'} onClick={() => this.handleToggleCreateModal()}>
                            {translate('btn.create_new')}
                        </button>
                    </div>
                )}

                <div className="flex m-4">
                    <ActiveFilters
                        filterFields={this.state.queryFilterFields}
                        onLabelClick={this.handleFilterInputChange}
                        onClearFiltersClick={this.handleClearFiltersClick}
                        translate={translate}
                    />
                </div>

                <TableCard addClass={'relative'}>
                    <TableFilters
                        hideLimit
                        filterFields={this.state.queryFilterFields}
                        handleInputChange={this.handleFilterInputChange}
                        translate={translate}
                        onRefreshTable={this.fetchData}
                        isLoading={secondResource.isLoading}
                    />

                    <ResourceTable
                        data={data}
                        fields={this.getFields()}

                        translate={translate}
                        isLoading={secondResource.isLoading}

                        options={this.state.tableOptions}

                        limit={this.state.queryFilterFields.limit.value}

                        sort={this.state.sort}
                        sortBy={this.state.sortBy}
                        onSortChange={this.handleUpdateSort}

                        actions={[
                            {
                                action: this.handleToggleEditModal,
                                icon: PencilIcon, // make this a function
                                visible: (it) => (checkPerm(this.getSettingsResource(), UPDATE_PERM)),
                                label: false, // make this a function
                                title: translate('btn.edit'),
                                disabled: false,
                                class: false,
                                iconClass: false
                            },
                            {
                                action: this.archiveResource,
                                icon: TrashIcon, // make this a function
                                visible: (it) => (!it.ArchivedDate && checkPerm(this.getSettingsResource(), DELETE_PERM)),
                                label: false, // make this a function
                                title: translate('btn.delete'),
                                disabled: false,
                                class: false,
                                iconClass: false
                            }
                        ]}
                    />

                    <TableCardFooter
                        show={!(!data.length && !secondResource.isLoading)}
                    >
                        <Pagination
                            count={count}
                            isLoading={secondResource.isLoading}
                            handleQueryChange={
                                (name, value, currentPage) => name === 'offset'
                                    ? this.handleUpdateOffset(value, currentPage)
                                    : this.handleFilterInputChange(name, value)
                            }
                            pageOffset={this.state.offset}
                            queryFields={this.state.queryFilterFields}
                            translate={translate}
                        />
                    </TableCardFooter>
                </TableCard>

                <ModalSaveResource
                    show={this.state.createModalOpen}
                    title={translate('text.create_override')}
                    widthClass="max-w-[32rem]"
                    gridColsClass="grid-cols-1"
                    onClose={this.handleToggleCreateModal}
                    fields={this.getFields(null, true)}
                    onSubmit={(params) => {
                        if (params) {
                            this.props.dispatch(createSecondResource({
                                user: LocalStorage.get('user'),
                                params: params,
                                query: this.getQuery(),
                                resource: this.getSettingsResource(),
                                piggyResource: this.getSettingsResource(),
                                errorMessage: true, successMessage: translate('message.item_created')
                            }))
                            this.handleToggleCreateModal()
                        }
                    }}
                    metadata={
                        {
                            ExpenseAccountID: {
                                api: 'api/' + Resources.AccountsQuick,
                                query: {
                                    MainAccountTypeID: MAJOR_ACCOUNT_TYPE_EXPENSE
                                },
                                searchMap: (item) => ({
                                    value: item.AccountID,
                                    label: item.AccountNumber + ' ' + item.AccountName
                                })
                            }
                        }
                    }
                    translate={translate}
                />

                <ModalSaveResource
                    show={this.state.editModalOpen}
                    title={translate('text.edit_override')}
                    widthClass="max-w-[32rem]"
                    gridColsClass="grid-cols-1"
                    onClose={this.handleToggleEditModal}
                    fields={this.getFields(this.state.selectedItem, true)}
                    onSubmit={(params) => {
                        if (params) {
                            params.PayrollSettingsID = this.state.selectedItem.PayrollSettingsID;
                            this.props.dispatch(updateSecondResource({
                                user: LocalStorage.get('user'),
                                params: params,
                                query: this.getQuery(),
                                resource: this.getSettingsResource(),
                                piggyResource: this.getSettingsResource(),
                                errorMessage: true, successMessage: translate('message.item_updated')
                            }))
                            this.handleToggleEditModal()
                        }
                    }}
                    translate={translate}
                />

                <ModalConfirm
                    title={'Confirm'}
                    show={!!this.state.confirmDialog}
                    text={this.state.text}
                    onClose={() => this.setState({confirmDialog: false})}
                    buttonLabel={translate('btn.confirm')}
                    closeButtonLabel={'Cancel'}
                    translate={translate}
                    onConfirm={this.state.confirmModal}
                />
            </div>

        )
    }
}
